import { render, staticRenderFns } from "./Form.component.vue?vue&type=template&id=6f57d210&scoped=true&"
import script from "./Form.component.vue?vue&type=script&lang=js&"
export * from "./Form.component.vue?vue&type=script&lang=js&"
import style0 from "./Form.component.vue?vue&type=style&index=0&id=6f57d210&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f57d210",
  null
  
)

export default component.exports